"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _differenceInMonths = _interopRequireDefault(require("date-fns/differenceInMonths"));
var _differenceInDays = _interopRequireDefault(require("date-fns/differenceInDays"));
var _formatDistanceToNow = _interopRequireDefault(require("date-fns/formatDistanceToNow"));
var _fromUnixTime = _interopRequireDefault(require("date-fns/fromUnixTime"));
var _ru = _interopRequireDefault(require("date-fns/locale/ru"));
var _date = require("../../../../utils/date");
var _userflow = require("../../../../constants/userflow");
var _formatDistance = _interopRequireDefault(require("./locale/formatDistance"));
var _excluded = ["full", "extend", "time"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var customLocale = _objectSpread(_objectSpread({}, _ru["default"]), {}, {
  formatDistance: _formatDistance["default"]
});
var UPDATE_INTERVAL = 60 * 1000;
var TimeFrom = /*#__PURE__*/function (_React$PureComponent) {
  function TimeFrom(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TimeFrom);
    _this = _callSuper(this, TimeFrom, [props]);
    _this.interval = void 0;
    _this.interval = 0;
    return _this;
  }
  (0, _inherits2["default"])(TimeFrom, _React$PureComponent);
  return (0, _createClass2["default"])(TimeFrom, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.interval = setInterval(this.update.bind(this), UPDATE_INTERVAL);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "update",
    value: function update() {
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$full = _this$props.full,
        isFull = _this$props$full === void 0 ? false : _this$props$full,
        _this$props$extend = _this$props.extend,
        extend = _this$props$extend === void 0 ? false : _this$props$extend,
        time = _this$props.time,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      if (TimeFrom.getCurrentTime() < time) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(StyledTimeFrom, (0, _extends2["default"])({
        title: TimeFrom.getTimeForTitle(time)
      }, props), isFull ? TimeFrom.getTimeFullFromNow(time, extend) : TimeFrom.getTimeFromNow(time));
    }
  }], [{
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return Math.round(new Date().getTime() / 1000);
    }
  }, {
    key: "getTimeForTitle",
    value: function getTimeForTitle(time) {
      var date = (0, _fromUnixTime["default"])(time);
      return (0, _date.formatDate)(date, _userflow.DATE_FULL_DATE);
    }
  }, {
    key: "getTimeFromNow",
    value: function getTimeFromNow(time) {
      var now = new Date();
      var date = (0, _fromUnixTime["default"])(time);
      var oneMonthIsOver = (0, _differenceInMonths["default"])(now, date) > 0;
      var result = (0, _formatDistanceToNow["default"])(date, {
        locale: customLocale
      });
      if (oneMonthIsOver) {
        return (0, _date.formatDate)(date, 'd MMM yyyy');
      }
      return result;
    }
  }, {
    key: "getTimeFullFromNow",
    value: function getTimeFullFromNow(time, extend) {
      var now = new Date();
      var date = (0, _fromUnixTime["default"])(time);
      var oneDayIsOver = (0, _differenceInDays["default"])(now, date) > 1;
      var fullDate = (0, _date.formatDate)(date, _userflow.DATE_FULL_DATE);
      var result = (0, _formatDistanceToNow["default"])(date, {
        addSuffix: true,
        locale: customLocale
      });
      if (oneDayIsOver) {
        return fullDate;
      }
      if (extend) {
        return "".concat(result, " (").concat(fullDate, ")");
      }
      return result;
    }
  }]);
}(_react["default"].PureComponent);
var StyledTimeFrom = _styledComponents["default"].div.withConfig({
  displayName: "TimeFrom__StyledTimeFrom",
  componentId: "sc-f2c8er-0"
})(["color:#919499;cursor:default;font-size:12px;"]);
var _default = exports["default"] = TimeFrom;